module.exports = __webpack_public_path__ + "static/img/xxtb5.1b0f62fa.png";